import React from "react";

import { createBrowserRouter } from "react-router-dom";
import DeprecatedPage from "../pages/DeprecatedPage";

const router = createBrowserRouter([
  {
    path: "/",
    element: <DeprecatedPage />,
  },
]);

export default router;
